<section>
  <h1>{{ eventDataSvc.mode }} Event <ng-container *ngIf="eventDataSvc.eventLECaseNumber$ | async as LECaseNumber"><span class="edit-event-subtitle">(LE Case # {{LECaseNumber}})</span></ng-container></h1>
  <p-messages key="eventFormMsg" [closable]="true"></p-messages>
  <form [formGroup]="eventFormGroup">
    <ng-container *ngIf="stepState$ | async as stepState">
      <ness-horizontal-stepper [linear]="true" [@.disabled]="true" labelPosition="bottom" #stepper selectedIndex="0" (selectionChange)="onStepChange($event)">
        <mat-step state="details" label="Event Details" [optional]="false" [completed]="stepState['detail']" [hasError]="!stepState['detail']">
          <ness-event-details></ness-event-details>
          <div class="d-flex justify-content-center">
            <button type="button" [disabled]="!stepState['detail']" matStepperNext class="btn btn-active btn-fixed-w120">Next <i class="fas fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </mat-step>
        <mat-step state="locations" label="Event Locations" [optional]="true" [completed]="stepState['locations']" [hasError]="!stepState['locations']">
          <ness-event-locations></ness-event-locations>
          <div class="d-flex justify-content-center">
            <button type="button" matStepperPrevious class="btn btn-active mb-2 me-2 btn-fixed-w120"><i class="fas fa-angle-left" aria-hidden="true"></i> Previous</button>
            <button type="button" matStepperNext class="btn btn-active mb-2 btn-fixed-w120">Next <i class="fas fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </mat-step>
        <mat-step [stepControl]="eventFormGroup.get('ENESS_XREF_EventsPeople')" state="people" label="Event People" [optional]="true" [completed]="stepState['people']" [hasError]="!stepState['people']">
          <ness-event-people></ness-event-people>
          <div class="d-flex justify-content-center">
            <button type="button" [disabled]="!stepState['locations']" matStepperPrevious class="btn btn-active mb-2 me-2 btn-fixed-w120"><i class="fas fa-angle-left" aria-hidden="true"></i> Previous</button>
            <button type="button" [disabled]="!stepState['attachments']" matStepperNext class="btn btn-active mb-2 btn-fixed-w120">Next <i class="fas fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </mat-step>
        <mat-step state="attachments" label="Event Attachments" [optional]="true" [completed]="stepState['attachments']" [hasError]="!stepState['attachments']">
          <ness-event-attachments></ness-event-attachments>
          <div class="d-flex justify-content-center">
            <button type="button" matStepperPrevious class="btn btn-active mb-2 me-2 btn-fixed-w120"><i class="fas fa-angle-left" aria-hidden="true"></i> Previous</button>
            <button type="button" matStepperNext class="btn btn-active mb-2 btn-fixed-w120">Next <i class="fas fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </mat-step>
        <mat-step state="summary" label="Event Summary" [optional]="false" [completed]="stepState['summary']" [hasError]="!stepState['summary']">
          <ness-event-summary #summary (targetStep)="selectTargetStep($event)" [submitted]="submitted"></ness-event-summary>
          <div class="d-flex justify-content-center">
            <button type="button" matStepperPrevious class="btn btn-active mb-2 me-2 btn-fixed-w120"><i class="fas fa-angle-left" aria-hidden="true"></i> Previous</button>
            <button *ngIf="stepper.selectedIndex == 4" type="button" [disabled]="submitted || eventFormGroup.invalid || isMissingPersonType()" (click)="onSubmit()" class="btn btn-active btn-fixed-w120 mb-2">Submit</button>
          </div>
        </mat-step>
        <!--Icon overrides.-->
        <ng-template matStepperIcon="details">
          <mat-icon fontSet="fas" fontIcon="fa-edit fa-md" aria-hidden="true"></mat-icon>
        </ng-template>
        <ng-template matStepperIcon="locations">
          <mat-icon fontSet="fas" fontIcon="fa-globe fa-md" aria-hidden="true"></mat-icon>
        </ng-template>
        <ng-template matStepperIcon="people">
          <mat-icon fontSet="fas" fontIcon="fa-user fa-md" aria-hidden="true"></mat-icon>
        </ng-template>
        <ng-template matStepperIcon="attachments">
          <mat-icon fontSet="fas" fontIcon="fa-paperclip fa-md" aria-hidden="true"></mat-icon>
        </ng-template>
        <ng-template matStepperIcon="summary">
          <mat-icon fontSet="fas" fontIcon="fa-check fa-md" aria-hidden="true" color="accent"></mat-icon>
        </ng-template>
      </ness-horizontal-stepper>
    </ng-container>
  </form>
</section>
